import React from 'react';
import MaterialUITypography, { TypographyProperties } from '../Typography';

const Headline4 = ({ tag, ...properties }: TypographyProperties) => (
  <MaterialUITypography
    tag={tag}
    variant="h4"
    {...properties}
  />
);

export default Headline4;
